export const CancleIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.00016 15.1667C4.04683 15.1667 0.833496 11.9533 0.833496 8C0.833496 4.04666 4.04683 0.833328 8.00016 0.833328C11.9535 0.833328 15.1668 4.04666 15.1668 8C15.1668 11.9533 11.9535 15.1667 8.00016 15.1667ZM8.00016 1.83333C4.60016 1.83333 1.8335 4.6 1.8335 8C1.8335 11.4 4.60016 14.1667 8.00016 14.1667C11.4002 14.1667 14.1668 11.4 14.1668 8C14.1668 4.6 11.4002 1.83333 8.00016 1.83333Z"
      fill={strokeColor}
    />
    <path
      d="M6.11357 10.3867C5.9869 10.3867 5.86023 10.34 5.76023 10.24C5.5669 10.0467 5.5669 9.72667 5.76023 9.53334L9.53357 5.76001C9.7269 5.56667 10.0469 5.56667 10.2402 5.76001C10.4336 5.95334 10.4336 6.27334 10.2402 6.46667L6.4669 10.24C6.37357 10.34 6.24023 10.3867 6.11357 10.3867Z"
      fill={strokeColor}
    />
    <path
      d="M9.8869 10.3867C9.76023 10.3867 9.63357 10.34 9.53357 10.24L5.76023 6.46667C5.5669 6.27334 5.5669 5.95334 5.76023 5.76001C5.95357 5.56667 6.27357 5.56667 6.4669 5.76001L10.2402 9.53334C10.4336 9.72667 10.4336 10.0467 10.2402 10.24C10.1402 10.34 10.0136 10.3867 9.8869 10.3867Z"
      fill={strokeColor}
    />
  </svg>
);
